export default "__VITE_ASSET__C6fq5l5Z__"